
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.656 1.938h1.735c.957 0 1.734.755 1.734 1.687v8.438c0 .931-.777 1.687-1.734 1.687H1.984c-.957 0-1.734-.756-1.734-1.688V3.626c0-.932.777-1.688 1.734-1.688H3.72v-.843c0-.467.388-.844.867-.844s.867.377.867.844v.843h3.469v-.843c0-.467.388-.844.867-.844s.867.377.867.844v.843zM1.984 12.062h10.407V4.89H1.984v7.173z","fill":"#9FA6AD"}})])
          )
        }
      }
    